import { observer } from 'mobx-react-lite'

import { Loader, useGlobalUiStore, WidgetContainer, useWidgetLoadTimer } from '../common'
import { WidgetProps } from '../core'

import { Help } from './components/Help'

export const HelpWidget = observer(({ onBackClick, onMenuClick, sx }: WidgetProps) => {
  const { isInitialized } = useGlobalUiStore()

  useWidgetLoadTimer({
    widgetName: 'HelpWidget',
    isLoaded: isInitialized,
  })

  if (!isInitialized) return <Loader />

  return (
    <WidgetContainer
      onBackClick={onBackClick}
      onMenuClick={onMenuClick}
      showAccountFilter={false}
      sx={{ p: 16 }}
    >
      <Help sx={sx} />
    </WidgetContainer>
  )
})
